<template>
  <div class="vml-page">
    <b-alert v-model="alert.show" :variant="alert.variant" dismissible fade>
      {{alert.message}}
    </b-alert>

    <div class="vml-header">
      <img v-if="summary.map_vehicles_logo" :src="summary.map_vehicles_logo" class="vml-logo"/>
      <div v-if="summary.label" class="vml-label">{{summary.label}}</div>
      <div v-if="header_details" class="vml-details">{{header_details}}</div>
      <div v-if="summary.status === 'active' && summary.end_display" class="vml-tracking-until">
        tracking until {{summary.end_display}}
      </div>
    </div>

    <div v-if="loading" class="vml-center-message">
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

    <div v-else-if="summary.status === 'upcoming'" class="vml-center-message">
      <h3>Live tracking begins {{summary.start_display}}</h3>
      <div class="vml-submessage">this page will update automatically once tracking starts</div>
    </div>

    <div v-else-if="summary.status === 'expired'" class="vml-center-message">
      <h3>This map link has expired</h3>
      <div v-if="summary.end_display" class="vml-submessage">live tracking ended {{summary.end_display}}</div>
    </div>

    <div v-else class="vml-body">
      <div v-if="!isMobile() && items.length > 0" class="vml-sidebar">
        <div @click="center_on_vehicle(veh.name)" v-for="(veh,idx) in items" :key="idx" class="vml-veh-row">
          <span v-if="veh.gps.speedMilesPerHour == 0" style="color: darkred; font-weight: bold">Bus #{{veh.name | trim(30)}}</span>
          <span v-else style="color: green; font-weight: bold">Bus #{{veh.name | trim(25)}}</span>
          <span v-if="vehicle_details_text(veh)"><br/>&nbsp;&nbsp;{{vehicle_details_text(veh)}}</span>
          <span v-if="veh.driver_name"><br/>&nbsp;&nbsp;{{veh.driver_name}}</span>
          <span v-if="veh.driver_phone"><br/>&nbsp;&nbsp;{{veh.driver_phone | prettyPhoneNumber}}</span>
        </div>
      </div>
      <div v-if="items.length > 0" class="vml-map-wrap">
        <GmapMap id="map" ref="mapRef"
                 :zoom="zoom"
                 :center="center"
                 :options="mapStyle"
                 class="vml-map"
        >
          <GmapMarker
              v-for="(marker,idx) in markers"
              :key="idx"
              :position="marker.position"
              :title="marker.title"
              :label="marker.label"
              :draggable="false"
              :clickable="true"
              :icon="marker.icon"
              @click="openInfoWindowTemplate(marker.bus_name)"
              @mouseover="openInfoWindowTemplate(marker.bus_name)"
              @mouseout="infoWindow.open=false"
          />
          <GmapInfoWindow
              :options="{
                            pixelOffset: { width: 0, height: -65 }
                          }"
              :position="infoWindow.position"
              :opened="infoWindow.open"
          >
            <div v-html="infoWindow.template"></div>
          </GmapInfoWindow>

        </GmapMap>
      </div>
      <div v-else class="vml-center-message">
        <h3>no vehicles reporting locations yet</h3>
        <div class="vml-submessage">this page refreshes automatically</div>
      </div>
    </div>
  </div>
</template>
<script>
import {get_map_link_track} from '../networking/apis'
import {gmapApi} from 'vue2-google-maps'

export default {
  name: 'vehicle_map_link',
  components: {
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      alert: {
        show: false,
        message: '',
        variant: ''
      },
      token: null,
      summary: {},
      items: [],
      loading: true,
      center: {lat: 39.917742615494085, lng: -97.13906071185122},
      zoom: 5,
      markers: [],
      reload_interval: 60000,
      timer: null,
      reload_inflight: false,
      bounds: null,
      infoWindow: {
        position: {lat: 0, lng: 0},
        open: false,
        template: ''
      },
      mapStyle: {
        styles: [
          {
            "featureType": "landscape",
            "stylers": [
              { "color": "#F3F4F9" }
            ]
          },          {
            "featureType": "water",
            "stylers": [
              { "color": "#C1CDE4" }
            ]
          },
          {
            "featureType": "landscape.natural.terrain",
            "stylers": [
              { "color": "#E0EDCA" }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [{color: '#DDDDDD'}]
          },
          {
            featureType: 'road',
            elementType: 'geometry.fill',
            stylers: [{color: '#FFFFFF'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [{color: '#FEF8D6'}]
          },
          {
            featureType: 'transit',
            stylers: [{"visibility": "off"}]
          },
          {
            featureType: 'poi',
            stylers: [{"visibility": "off"}]
          },
        ]
      }
    }
  },
  async created() {
    this.token = this.$route.params.token
    await this.load_data()
  },
  beforeDestroy() {
    this.stopTimer()
  },
  methods: {
    startTimer() {
      this.stopTimer()
      // keep polling while upcoming (so the page flips to live on its own)
      // and while active; expired links stop for good
      if (this.summary.status === 'upcoming' || this.summary.status === 'active') {
        this.timer = setInterval(() => this.reload_data(), this.reload_interval)
      }
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    async resetTimerAndReload() {
      this.stopTimer()
      await this.reload_data()
      this.startTimer()
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    openInfoWindowTemplate(selected_name) {
      const loc = this.items.filter(item => item.name == selected_name)[0]

      if (loc != null) {
        const position = {
          lat: Number(loc.gps.latitude),
          lng: Number(loc.gps.longitude),
        };
        this.infoWindow.position = position
        this.infoWindow.template = loc.marker_html
        this.infoWindow.open = true
      }
    },
    center_on_vehicle(selected_name) {
      const loc = this.items.filter(item => item.name == selected_name)[0]
      if (loc != null) {
        this.center = {
          lat: Number(loc.gps.latitude),
          lng: Number(loc.gps.longitude),
        };
        this.zoom = 13
      }
    },
    async load_data() {
      this.loading = true
      try {
        const results = await get_map_link_track(this.token)
        const {value: { data = [] } } = results

        this.summary = data.summary
        this.items = data.results || []
        this.markers = []

        if (this.summary.status === 'active' && this.items.length > 0) {
          this.zoom = this.summary.zoom

          for (const loc of this.items) {
            const position = {
              lat: Number(loc.gps.latitude),
              lng: Number(loc.gps.longitude),
            };
            this.center = position;

            const marker_title = "Vehicle #" + loc.name
            this.markers.push({
              position: position,
              heading: loc.gps.headingDegrees,
              title: marker_title,
              bus_name: loc.name,
              label: {text: marker_title, className: 'tracking-label'},
              icon: this.arrowSymbol(loc.gps)
            });
          }

          if (this.markers.length > 1)
            this.fitMapToMarkers()
        }

        this.loading = false
        this.startTimer()
      } catch(e) {
        this.loading = false
        this.alert = {show: true, message: "error retrieving data, try again later or contact support if needed", variant: 'danger'}
      }
    },
    async fitMapToMarkers() {
      if (!this.$refs.mapRef) {
        let cnt=0;
        while(cnt<10) {
          if (this.$refs.mapRef)
            break;
          await this.sleep(500);
          cnt++;
        }
        if (!this.$refs.mapRef)
          return
      }

      this.bounds = new this.google.maps.LatLngBounds();
      for (const marker of this.markers)
        this.bounds.extend(marker.position);

      this.$refs.mapRef.$mapObject.fitBounds(this.bounds);
    },
    async reload_data() {
      try {
        if (this.$pageVisibility && this.$pageVisibility.hidden) {
          return
        }
        if (this.reload_inflight) {
          return
        }
        this.reload_inflight = true

        const results = await get_map_link_track(this.token)
        const {value: { data = [] } } = results

        const previous_status = this.summary.status
        this.summary = data.summary
        this.items = data.results || []

        if (this.summary.status !== 'active') {
          // window closed (or hasn't opened yet); drop the markers so the
          // status message renders, and stop polling once expired
          this.markers = []
          if (this.summary.status === 'expired')
            this.stopTimer()
          this.reload_inflight = false
          return
        }

        if (previous_status !== 'active') {
          // just went live - rebuild the map from scratch
          this.reload_inflight = false
          await this.load_data()
          return
        }

        for (const loc of this.items) {
          const position = {
            lat: Number(loc.gps.latitude),
            lng: Number(loc.gps.longitude),
          };

          let current_marker_idx = this.markers.findIndex(x => x.bus_name === loc.name);
          const marker_title = "Vehicle #" + loc.name;

          if (current_marker_idx == -1) {
            this.markers.push({position: position, heading: loc.gps.headingDegrees, title: marker_title, bus_name: loc.name, label: {text: marker_title, className: 'tracking-label'}, icon: this.arrowSymbol(loc.gps)});
          } else {
            this.animatedMove(this.markers[current_marker_idx], loc.gps);
          }
        }

        const markers_to_remove = []
        for (const old_marker of this.markers) {
          let marker_idx = this.items.findIndex(x => x.name === old_marker.bus_name);
          if (marker_idx == -1)
            markers_to_remove.push(old_marker.bus_name);
        }
        if (markers_to_remove.length > 0) {
          this.markers = this.markers.filter(item => !markers_to_remove.includes(item.bus_name))
        }
      } catch(e) {
        this.alert = {show: true, message: "error retrieving data, try again later or contact support if needed", variant: 'danger'}
      } finally {
        this.reload_inflight = false
      }

    },
    animatedMove(marker, new_loc) {

      const new_position = {
        lat: Number(new_loc.latitude),
        lng: Number(new_loc.longitude),
      };

      let new_heading = Number(new_loc.headingDegrees);
      let old_heading = marker.icon.rotation;

      if (new_heading == 0)
        new_heading = marker.icon.rotation;
      if (old_heading == 0 || isNaN(old_heading))
        marker.icon.rotation = new_heading;

      marker.speed = new_loc.speedMilesPerHour;

      var delta_incr = 100;

      var deltalat = (new_position.lat - marker.position.lat) / delta_incr;
      var deltalng = (new_position.lng - marker.position.lng) / delta_incr;
      var deltaheading = (new_heading - marker.icon.rotation) / delta_incr;

      var direction = 'clockwise';
      if (new_heading > old_heading) {
        if ((new_heading - old_heading) > 180) {
          direction = 'counterclockwise';
          deltaheading = (old_heading + (360-new_heading)) / delta_incr;
        } else {
          deltaheading = (new_heading - old_heading) / delta_incr;
        }
      } else if (old_heading > new_heading) {
        if ((old_heading - new_heading) > 180) {
          deltaheading = (new_heading + (360-old_heading)) / delta_incr;
        } else {
          deltaheading = (old_heading - new_heading) / delta_incr;
          direction = 'counterclockwise';
        }
      }

      if (Math.abs(old_heading - new_heading) < 2)
        deltaheading = 0;

      var delay = this.reload_interval/delta_incr;

      for (var i = 0; i < delta_incr; i++) {
        (function(ind) {
          setTimeout(
              function() {
                let incr_position = {
                  lat: (marker.position.lat + deltalat),
                  lng: (marker.position.lng + deltalng),
                };
                marker.position = incr_position;

                if (deltaheading != 0) {
                  if (direction == 'clockwise')
                    marker.icon.rotation = Number(marker.icon.rotation + deltaheading);
                  else
                    marker.icon.rotation = Number(marker.icon.rotation - deltaheading);

                  if (marker.icon.rotation > 360) {
                    marker.icon.rotation = 0;
                  }

                  if (Math.floor(marker.icon.rotation) != (Math.floor(marker.icon.rotation + deltaheading))) {
                    marker.icon =
                        {
                          path: (new_loc.speedMilesPerHour == 0 || new_heading == 0) ? "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0" : "M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14",
                          scale: 1.5,
                          strokeColor: "white",
                          strokeStyle: "bold",
                          fillColor: new_loc.speedMilesPerHour == 0 ? "darkred" : "#29C68A",
                          fillOpacity: .6,
                          rotation: marker.icon.rotation
                        }
                  }
                }
              }, delay * ind
          );
        })(i)
      }
    },
    arrowSymbol(loc) {
      return {
        path: (loc.speedMilesPerHour == 0 || loc.headingDegrees == 0) ? "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0" : "M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14",
        scale: 1.5,
        strokeColor: "white",
        strokeStyle: "bold",
        fillColor: loc.speedMilesPerHour == 0 ? "darkred" : "#29C68A",
        fillOpacity: 1,
        rotation: Number(loc.headingDegrees)
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    vehicle_details_text(veh) {
      const details = veh.vehicle_details
      if (!details) return ''
      return [details.description, details.plate ? 'Plate ' + details.plate : ''].filter(Boolean).join(' · ')
    },
  },
  computed:{
    google: gmapApi,
    header_details() {
      // single-bus links repeat the details up top: the sidebar listing them
      // is hidden on phones, which is where most of these links get opened.
      // keyed on vehicle_details (verizon only) so other providers' links,
      // which may already list a driver via Show Driver Phone, look the same
      if (this.items.length !== 1) return ''
      const veh = this.items[0]
      const details = this.vehicle_details_text(veh)
      if (!details) return ''
      return ['Bus #' + veh.name, details, veh.driver_name ? 'Driver: ' + veh.driver_name : ''].filter(Boolean).join(' · ')
    },
  },
  watch: {
    '$pageVisibility.hidden'(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.resetTimerAndReload()
      }
    }
  }
}
</script>
<style scope>

/* full-viewport chromeless layout - this page is rendered outside the app
   shell (App.vue), so it owns the whole screen. dvh over vh where possible
   since mobile browser chrome (address bar) resizing shouldn't clip the map. */
.vml-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
}

.vml-header {
  flex: 0 0 auto;
  text-align: center;
  padding: 10px 12px 6px;
}

.vml-logo {
  max-height: 64px;
  max-width: 85vw;
}

.vml-label {
  font-weight: bold;
  font-size: 22px;
  margin-top: 4px;
}

.vml-details {
  font-size: 16px;
  font-weight: 600;
  margin-top: 2px;
}

.vml-tracking-until {
  font-size: 13px;
  color: #666;
  margin-top: 2px;
}

.vml-center-message {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
  font-size: 20px;
  font-weight: bold;
}

.vml-submessage {
  font-size: 15px;
  font-weight: normal;
  color: #666;
  margin-top: 10px;
}

.vml-body {
  flex: 1;
  display: flex;
  min-height: 0;
}

.vml-sidebar {
  flex: 0 0 320px;
  overflow-y: auto;
  padding: 10px 14px;
  border-right: 1px solid #ddd;
}

.vml-veh-row {
  font-size: 18px;
  text-align: left;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

.vml-map-wrap {
  flex: 1;
  min-width: 0;
}

.vml-map {
  width: 100%;
  height: 100%;
}

@media (max-width: 480px) {
  .vml-label {
    font-size: 18px;
  }
  .vml-details {
    font-size: 14px;
  }
  .vml-logo {
    max-height: 48px;
  }
  .vml-center-message {
    font-size: 17px;
  }
}

.tracking-label {
  opacity: 0.8;
  font-size: 12px;
  bottom: 35px;
  position: relative;
  border: 1px solid black;
  background-color: #333;
  color: white !important;
  border-radius: 2px;
  padding: 2px;
}

</style>
